import { Link } from 'react-router-dom';
import { API_BASE_URL, openInGoogleMaps } from '../../utils';
import './VenuesCardNew.css'
import { IoRestaurant } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlinePushPin } from "react-icons/md";
import buffe from '../image/buffe.png'
import { IoLocationOutline } from "react-icons/io5";
import { FaDirections } from "react-icons/fa";

import { BiDrink } from "react-icons/bi";
import TextRoller from './TextRoller';
import PlatformChargesTooltip from './PlatformChargesTooltip';
import ShareModal from '../../Feed Page/custom-comp/ShareModal';
import { useState } from 'react';
import { HiOutlineLocationMarker } from "react-icons/hi";
import { CiHeart } from "react-icons/ci";
import ClubProfileSection from './ClubProfileSection';
import MoreFeatureShow from './MoreFeatureShow';


const url = `${API_BASE_URL}/master/assets/uploads/`
export default function VenuesCardNew({ data, isFiltered }) {


    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [shareTitle, setShareTitle] = useState('');
    const [currentShareUrl, setCurrentShareUrl] = useState('');
    const [showMoreModal, setShowMoreModal] = useState(false);



    const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }

    function generateClubDetailUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }


    const messages = [
        `Great Choice! ₹${Number(data?.mrp) - Number(data?.price)} Saved This Booking!`,
        `Great Choice! ₹${Number(data?.mrp) - Number(data?.price)} Saved Instantly on This Booking!`,
        `Great Choice! ₹${Number(data?.mrp) - Number(data?.price)} Saved`,
    ];
    const packageMessages = [
        `Party smarter: Save ₹750 instantly`,
        `Great Choice! Save ₹750 Saved Instantly on This Booking!`,
    ];

    const packageUrl = (clubName, cityName, areaName, title) => {
        return `${API_BASE_URL}/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    };
    const venueUrl = (clubName, cityName, areaName, title) => {
        return `${API_BASE_URL}/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    };

    const BidDetailUrl = (clubName, cityName, areaName, title, id) => {
        return `${API_BASE_URL}/bid-detail/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}/${id}`;
    };

    const generateEventUrl = (slug1, slug2) => {
        return `${API_BASE_URL}/event/${slug1}/${slug2}`;
    };

    const handleShare = (e, eventData) => {
        e.preventDefault();
        e.stopPropagation();

        let url = venueUrl(eventData.clubName, eventData.cityName, eventData.areaName);


        setCurrentShareUrl(url);
        setShareTitle(`Check out ${eventData.clubName}${eventData.title ? " - " + eventData.title : ""}`);
        setIsShareModalOpen(true);
    };




    return (
        <>

            <div className='venues-new-card'>
                <div className='event-new-card-image-section position-relative' style={{ backgroundImage: `url(${url + data?.profile_pic})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} >
                    <div className='event-detail-page-design-content1-img-blur-overlay'>

                        <div className='icon-seton-image'>
                            <div className='d-flex gap-2'>
                                <div className='pnats-icon-wrapper-icon-desktop icon cursor-pointer' onClick={(e) => handleShare(e, data)}>
                                    <CiHeart size={22} />
                                </div>
                                <div className='pnats-icon-wrapper-icon-mobile icon cursor-pointer ' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={22} />
                                </div>
                            </div>
                        </div>
                        <img
                            src={url + data?.profile_pic}
                            alt=""
                            onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop
                                e.target.src =
                                    "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
                            }}
                        />
                    </div>

                </div>


                <div className='venues-new-card-image-section-wrapper'>
                    <div className='venues-new-card-content-section'>
                        <div className='venues-new-card-text-section-wrapper'>
                            <div className='venues-new-card-text-section'>

                                <ClubProfileSection clublogo={data?.clubLogo ? url + data.clubLogo : url + data?.profile_pic} address={data?.address} distance={data?.distance} name={data?.clubName || data?.name} />

                                <>
                                    {data?.events?.length > 0 ? (
                                        <div className='d-flex flex-column gap-2 align-items-start '>
                                            <div>
                                                <h6 className='font-14r'>Live Events</h6>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <div className='time-onwards-bid-new-card'>
                                                    <h2>{data?.events[0]?.event_date}<br /> {data?.events[0]?.event_time} Onwards</h2>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="106" height="50" viewBox="0 0 106 50" fill="none">
                                                        <path d="M91.2722 4.46062C90.2252 1.77121 87.635 0 84.749 0H7C3.13401 0 -7.62939e-06 3.13401 -7.62939e-06 7V43C-7.62939e-06 46.866 3.134 50 6.99999 50H98.7633C103.688 50 107.073 45.0497 105.286 40.4606L91.2722 4.46062Z" fill="url(#paint0_linear_1434_33243)" />
                                                        <defs>
                                                            <linearGradient id="paint0_linear_1434_33243" x1="110.506" y1="48.9394" x2="-2.86794" y2="7.92836" gradientUnits="userSpaceOnUse">
                                                                <stop stop-color="#7464E4" />
                                                                <stop offset="1" stop-color="#1A00D2" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                </div>
                                                {data?.events?.length > 1 && (
                                                    <div>
                                                        <a className='text-gradient-set' href=''>+{data?.events?.length - 1} More</a>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='d-flex flex-column gap-2 align-items-start '>
                                            <div>
                                                <h6 className='font-14r'>Live Events</h6>
                                            </div>
                                            <div className='time-onwards-bid-new-card'>
                                                <h2>No event<br /> scheduled </h2>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="106" height="50" viewBox="0 0 106 50" fill="none">
                                                    <path d="M91.2722 4.46062C90.2252 1.77121 87.635 0 84.749 0H7C3.13401 0 -7.62939e-06 3.13401 -7.62939e-06 7V43C-7.62939e-06 46.866 3.134 50 6.99999 50H98.7633C103.688 50 107.073 45.0497 105.286 40.4606L91.2722 4.46062Z" fill="url(#paint0_linear_1434_33243)" />
                                                    <defs>
                                                        <linearGradient id="paint0_linear_1434_33243" x1="110.506" y1="48.9394" x2="-2.86794" y2="7.92836" gradientUnits="userSpaceOnUse">
                                                            <stop stop-color="#7464E4" />
                                                            <stop offset="1" stop-color="#1A00D2" />
                                                        </linearGradient>
                                                    </defs>
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                </>



                            </div>
                            {/* <div>
                                <div className='pnats-icon-wrapper-icon-mobile' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={25} />
                                </div>
                            </div> */}
                        </div>

                        <div className='venues-new-card-about-text-section'>
                            <div className='pnats-icon-wrapper'>


                                {isFiltered && (
                                    <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon2'>
                                        <MdOutlineFilterAlt size={22} />
                                        <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon3'>
                                            <MdOutlinePushPin size={10} />
                                        </div>
                                    </div>
                                )}
                            </div>




                            <div className='PackageNewCard-about-text-section'>

                                <h1>Features</h1>
                                <div>
                                    <ul className="PackageNewCard-about-text-section-list">
                                        {data?.features?.slice(0, 4).map((item) => (
                                            <li key={item?.id}>{item?.title}</li>
                                        ))}
                                    </ul>

                                </div>
                                {data?.features?.length > 4 && (
                                    <p
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setShowMoreModal(true);
                                        }}
                                    >{data.features.length - 4}+ More</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='w-100 d-flex flex-column justify-content-center gap-2'>

                        <Link to={generateClubDetailUrl(data?.name, data?.cityName, data?.areaName, data?.title)} style={{ textDecoration: "none", width: "100%" }}>
                            <div className='venues-new-card-text-section-button'>
                                <button className='btn text-btn m-hide'>View Details</button>
                                <div className='venues-new-card-break-line'></div>
                                <div className='venues-new-card-text-section-text-wrapper'>
                                    <TextRoller messages={packageMessages} />
                                </div>
                            </div>
                        </Link>

                        <Link className='w-100 d-flex flex-column justify-content-center' to={generateClubDetailUrl(data?.name, data?.cityName, data?.areaName, data?.title)} style={{ textDecoration: "none", width: "100%" }}>
                            <button className='btn text-btn d-hide'>View Details</button>

                        </Link>
                    </div>



                </div>

            </div>

            <ShareModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                shareUrl={currentShareUrl}
                title={shareTitle}
            />
            <MoreFeatureShow
                isOpen={showMoreModal}
                onClose={() => setShowMoreModal(false)}
                title="Features"
                inclusions={data?.features}
            />
        </>
    )
}
